import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_CONFIGURATION } from '../../data.const';
import {
  retrieveConfigurationListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteConfigurationEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_CONFIGURATION),
    map(({ payload: { ids, isCestino, ...rest } }: any) => ({
      body: {
        ids,
        isCestino,
      },
      listBody: { ...rest, isCestino },
    })),
    // tap(p => console.log(`[epic ${DELETE_CONFIGURATION}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ configurationLoader: true })),
        defer(() =>
          from(
            request({ path: `configuration`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_CONFIGURATION}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveConfigurationListAction(listBody))),
            catchError((err) => {
              console.error(`[epic ${DELETE_CONFIGURATION}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ configurationLoader: false }))
      );
    })
  );

export default deleteConfigurationEpic;
